export default __webpack_public_path__ + "static/media/dark-moon.916dc9ef.svg";